<template>
  <el-breadcrumb :key="levelList.length" class="app-breadcrumb" separator="/">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="(item,index) in levelList" :key="index + item.menuId">
        <span v-if="index==levelList.length-1" class="no-redirect">{{ item.meta.title }}</span>
        <a v-else @click.prevent="handleLink(item)">{{ item.meta.title }}</a>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
import {nameComponentObj} from "@/assets/menu/index.js"
import {getPathByTreeValue} from "vue2-element-admin-plugin"
export default {
  data() {
    return {
      levelList: []
    }
  },
  watch: {
    $route: {
      handler(val) {
        this.getBreadcrumb(this.$route.fullPath)
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.$bus.$on("setBreadcrumbByFullPath", ({fullPath, title}) => {
      for (const v of this.levelList) {
        if (v.fullPath === fullPath) {
          v.meta.title = title
          break
        }
      }
    })
  },
  beforeDestroy() { this.$bus.$off("setBreadcrumbByFullPath") },
  methods: {
    // 寻找根节点的path
    getLeafPath(item) {
      if (item.children && item.children.length > 0) {
        const childItem = item.children[0]
        return this.getLeafPath(childItem)
      }
      return item.path
    },
    // 获取面包屑列表
    getBreadcrumb(fullPath) {
      this.levelList = []
      let matched = []
      const targetId = this.$route.meta[this.$store.state.user.treeConfig.idField]
      if (targetId) {
        matched = getPathByTreeValue(this.$store.state.user.sidebarMenuTree, targetId, {targetField: "menuId"})
        matched = matched.map(item => {
          const redirect = this.getLeafPath(item)
          return {
            redirect,
            ...item
          }
        })
      } 
      matched.unshift(nameComponentObj["dashboard"])

      this.levelList = matched.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== "0")
      // 设置fullPath  用于修改title
      this.levelList[this.levelList.length - 1].fullPath = fullPath
    },
    handleLink(item) {
      const {fullPath} = this.$route
      const { redirect, path } = item
      if (redirect) {
        if (redirect === fullPath) { return }
        this.$router.push(redirect)
        return
      }
      if (path === fullPath) { return }
      this.$router.push(path)
    }
  }
}
</script>

<style lang="scss" scoped>
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  margin-left: 0px;
  padding-left: 12px;
  .no-redirect {
    cursor: text;
    font-weight: bold;
    color: #fff;
  }
  ::v-deep .el-breadcrumb__separator {
    color: rgba(255,255,255,0.8);
  }
  a {
    font-weight: normal;
    color: rgba(255,255,255,0.8);
    &:hover {
      font-weight: bold;
      color: #fff;
    }
  }
}
</style>
